import { fetch as fetchRaw } from '@lib/fetch';
import { companies } from '../services';
import {
  bulkUnlinkCompany,
  getBulkCompanyProfiles,
  getCompanyProfile,
  getImpactAreasHierarchy,
  linkCompany,
  listCompanies,
  listDataPointAnswers,
  unlinkCompany,
} from './backend';

const fetch = (url, ...args) => fetchRaw([companies.url, url], ...args);

/**
 * Delegates to the modules-backed `/companies/templates/:templateId/profile/:forCompanyId`
 * route. Kept as a thin re-export here (rather than repointing call sites) since this
 * wrapper has 40+ callers across many unrelated views.
 *
 * @param {('ABOUT'|'OPERATIONAL_METRICS'|'OTHER_IDS')} templateId
 * @param {string} forCompanyId
 * @returns
 */
export const getCompanyProfileById = (templateId, forCompanyId) => {
  return getCompanyProfile(templateId, forCompanyId);
};

/**
 * Delegates to the modules-backed `/companies` route. Kept as a thin
 * re-export here (rather than repointing call sites) since this wrapper has
 * 80+ callers across many unrelated views.
 */
export function getCompaniesList(queryParams) {
  return listCompanies(queryParams);
}

/**
 * Delegates to the modules-backed `/companies/link` route. Kept as a thin
 * re-export here (rather than repointing call sites).
 */
export function companyLink(body) {
  return linkCompany(body);
}

/**
 * Delegates to the modules-backed `/companies/unlink` route. Kept as a thin
 * re-export here (rather than repointing call sites).
 */
export function companyUnLink(body) {
  return unlinkCompany(body);
}

/**
 * Delegates to the modules-backed `/companies/bulk-unlink` route. Kept as a
 * thin re-export here (rather than repointing call sites).
 */
export function companyBulkUnLink(body) {
  return bulkUnlinkCompany(body);
}

export function shareAsset(body) {
  return fetch('/v1/assets/share', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function getAssetAccessControl(assetId) {
  return fetch(`/v1/assets/access-control/${assetId}`, {
    method: 'GET',
  });
}

/**
 * Delegates to the modules-backed `/companies/templates/:templateId/profiles`
 * route. Kept as a thin re-export here (rather than repointing call sites).
 */
export function getGlobalCompanyProfiles(profileType, queryParams) {
  return getBulkCompanyProfiles(profileType, queryParams.forCompanyIds);
}

/**
 * Delegates to the modules-backed `/companies/impact-areas/hierarchy/:sectionId`
 * route. Kept as a thin re-export here (rather than repointing call sites).
 */
export const getImpactAreasBySectionId = sectionId => {
  return getImpactAreasHierarchy(sectionId);
};

/**
 * Delegates to the modules-backed `/companies/:forCompanyId/data-points-answers`
 * route. Kept as a thin re-export here (rather than repointing call sites).
 */
export const listDataPointsAnswers = (companyId, queryParams) => {
  return listDataPointAnswers(companyId, queryParams);
};

export {
  getCompaniesDirectorySearch,
  getCompaniesListVectorSearch,
  getPendingCompanyJoinRequests,
  postApproveCompanyJoinRequest,
  postCompanyJoinRequest,
  postRejectCompanyJoinRequest,
} from './companies/index';
